import { render } from "./SmartMiningDashboardView.vue?vue&type=template&id=4580431b&scoped=true"
import script from "./SmartMiningDashboardView.vue?vue&type=script&lang=js"
export * from "./SmartMiningDashboardView.vue?vue&type=script&lang=js"

import "./SmartMiningDashboardView.vue?vue&type=style&index=0&id=4580431b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4580431b"]])

export default __exports__